import {getApp} from "@/api/request";

export const getAppSource = params => getApp("/source", params)//首页广告